// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3S_Hh","content":"styles_content__PzAv7","checkbox":"styles_checkbox__21Tnr","checkboxLabel":"styles_checkboxLabel__1inGa"};